import { h, Host, } from "@stencil/core";
import state from "../store";
import { exportParts } from "../../common/export-parts";
export class GxgPill {
    constructor() {
        this.disabled = false;
        this.icon = undefined;
        this.heightAuto = false;
        this.id = undefined;
        this.italic = false;
        this.type = "static";
    }
    parts = {
        removeButton: "remove-button",
    };
    exportparts;
    el;
    pillRemoved;
    componentWillLoad() {
        this.attachExportParts();
    }
    attachExportParts = () => {
        const part = this.el.getAttribute("part");
        const exportPartsResult = exportParts(part, this.parts);
        exportPartsResult.length && (this.exportparts = exportPartsResult);
    };
    removeButtonFunc() {
        this.pillRemoved.emit(this.id);
        this.el.classList.add("hide");
        setTimeout(() => {
            this.el.remove();
        }, 250);
    }
    iconType() {
        if (this.icon !== undefined) {
            return this.icon;
        }
        else {
            return "gemini-tools/empty";
        }
    }
    iconColor() {
        if (state.mercury) {
            return "mercury";
        }
        else if (this.disabled) {
            return "disabled";
        }
        else {
            return "success";
        }
    }
    render() {
        return (h(Host, { tabindex: "0", class: {
                "no-icon": this.icon === undefined,
                "has-icon": this.icon !== undefined,
                large: state.large,
                mercury: state.mercury,
            }, exportParts: this.exportparts ? this.exportparts : null }, h("gxg-icon", { class: "custom", type: this.iconType(), size: "regular", color: this.iconColor() }), h("span", { class: "title" }, h("slot", null)), this.type === "button-with-action" ||
            this.type === "static-with-action" ? (h("gxg-icon", { class: "clear-button", type: "gemini-tools/close", size: "small", color: "onbackground", onClick: this.removeButtonFunc.bind(this), part: this.parts.removeButton })) : null));
    }
    static get is() { return "gxg-pill"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["pill.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["pill.css"]
        };
    }
    static get properties() {
        return {
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute disables the pill"
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            },
            "icon": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The icon"
                },
                "attribute": "icon",
                "reflect": false,
                "defaultValue": "undefined"
            },
            "heightAuto": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute sets auto-height. Useful when the text overflows."
                },
                "attribute": "height-auto",
                "reflect": false,
                "defaultValue": "false"
            },
            "id": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The pill id"
                },
                "attribute": "id",
                "reflect": false
            },
            "italic": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Stylizes the font with italic (only used in mercury)"
                },
                "attribute": "italic",
                "reflect": false,
                "defaultValue": "false"
            },
            "type": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "PillType",
                    "resolved": "\"button\" | \"button-with-action\" | \"static\" | \"static-with-action\"",
                    "references": {
                        "PillType": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/pills/pill.tsx",
                            "id": "src/components/pills/pill.tsx::PillType"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The type of pill"
                },
                "attribute": "type",
                "reflect": true,
                "defaultValue": "\"static\""
            }
        };
    }
    static get events() {
        return [{
                "method": "pillRemoved",
                "name": "pillRemoved",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=pill.js.map
